"use client";

import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ApplicationDetails } from "@/features/common/applicationDetailtOrCandidateProfile";

export default function ApplicationForm({
  showBreadcrumbs = true
}: {
  showBreadcrumbs?: boolean;
}) {
  const { id } = useParams();
  const { t } = useTranslation(["applications"]);

  if (!id) {
    return <div>{t("messages.error_occurred")}</div>;
  }

  return (
    <ApplicationDetails
      id={id}
      breadcrumbs={
        showBreadcrumbs
          ? [
              { title: t("breadcrumbs.home"), href: "/" },
              { title: t("breadcrumbs.applications"), href: "/applications" },
              { title: t("sections.job_details.title") }
            ]
          : undefined
      }
    />
  );
}
